import { render } from "./RightMenu.vue?vue&type=template&id=2104a670"
import script from "./RightMenu.vue?vue&type=script&lang=js"
export * from "./RightMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__